// File generato da scripts/writeVersion.js: non modificarlo a mano.
export const APP_VERSION = "0.2.0"
export const BUILD_COMMIT = "57e721b"
